import { render } from "./Settings2.vue?vue&type=template&id=2844d444&scoped=true&ts=true"
import script from "./Settings2.vue?vue&type=script&lang=ts"
export * from "./Settings2.vue?vue&type=script&lang=ts"

import "./Settings2.vue?vue&type=style&index=0&id=2844d444&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2844d444"]])

export default __exports__